<template>
  <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>

        <v-card-text>
          {{description}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="confirm"
            :loading="loading"
          >
            Đồng ý
          </v-btn>

          <v-btn
            color="grey darken-1"
            flat="flat"
            @click="close"
          >
            Hủy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Cảnh báo'
    },
    description: {
      type: String,
      default: 'Bạn có chắc muốn xóa trường này?'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    dialog: false
  }),

  methods: {
    open () {
      this.dialog = true;
    },
    
    close () {
      this.dialog = false;
    },

    confirm () {
      this.$emit('confirm');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DialogConfirmNotify.vue